// The property strategy tool's call to strategy-register (Stage 2, docs/property-strategy-spec.md S2.8), as the replay
// register page calls replay-register (src/free/register.js callReplayRegister): a POST with JSON and the publishable
// key on apikey only, never a member's token. Pure, so it's tested in Node (tests/strategy/calls.test.mjs).
export const STRATEGY_ERRORS = ['first_name', 'email', 'version', 'answers', 'unfinished', 'busy', 'failed']

// body: { first_name, email, src, website, emails, session } (emails false when the box "Don't send me emails" is
// ticked, 29 Oct 2026). Answers { ok: true } or { ok: false, error }, error 1 of
// STRATEGY_ERRORS. conn: { url, key } (the Supabase address and the publishable key) and, for a test, fetchImpl.
export async function callStrategyRegister(body, { url, key, fetchImpl = globalThis.fetch } = {}) {
  let res
  try {
    res = await fetchImpl(`${url}/functions/v1/strategy-register`, {
      method: 'POST',
      headers: { 'content-type': 'application/json', apikey: key },
      body: JSON.stringify(body),
      // the save still goes if the visitor closes the tab straight after Show my report
      keepalive: true,
    })
  } catch {
    return { ok: false, error: 'failed' }
  }
  let answer = null
  try { answer = await res.json() } catch { answer = null }
  if (res.ok && answer && answer.ok === true) return { ok: true }
  if (answer && answer.ok === false && STRATEGY_ERRORS.includes(answer.error)) return { ok: false, error: answer.error }
  return { ok: false, error: res.status === 429 ? 'busy' : 'failed' }
}
